import { useAuth } from "./contexts/authContext";
import InstitutionDashboard from "./components/InstitutionDashboard";
import { Typography } from "@mui/material";

function InstitutionalPage() {
    const { institutionalRoles, mainInstitutionDisplayName } = useAuth()

    return <>
        <Typography gutterBottom variant="h3" component="div" sx={{ color: '#003366', fontWeight: 'bold' }}>
            {mainInstitutionDisplayName} Dashboard
        </Typography>
        <InstitutionDashboard institutionId={institutionalRoles[0][0]} institutionalRole={institutionalRoles[0][1]} institutionName={mainInstitutionDisplayName} mode="advanced"></InstitutionDashboard>
    </>

}

export default InstitutionalPage;